import { provideWidgetClass } from "scrivito"

export const SliderWidget = provideWidgetClass("SliderWidget", {
  attributes: {
    autoplay: "boolean",
    autoplayInterval: "float",
    controls: "boolean",
    marginTop: [
      "enum",
      { values: ["mt-0", "mt-1", "mt-2", "mt-3", "mt-4", "mt-5"] }
    ],
    margin: [
      "enum",
      { values: ["mb-0", "mb-1", "mb-2", "mb-3", "mb-4", "mb-5"] }
    ],
    slides: ["widgetlist", { only: "SlideWidget" }]
  },
  extractTextAttributes: ["slides"]
})
